import { ICodesGlosa, ICodesGlosaResponse } from "shared/models"

export const convertCodesGlossas = (options: ICodesGlosaResponse[]): ICodesGlosa[] => {
    return options.map(option => {
        return {
            id: option.id,
            name: `${option.code } - ${option.name}`,
        }
      })
}